var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DashboardTemplate',[_c('Layout',{staticClass:"pd-y-3"},[_c('FormData',{attrs:{"edit":true,"routerBack":"/system/admin","ruleForm":_vm.ruleForm,"validate":true},on:{"emitData":_vm.saveData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }